export const BASE_DAYS = 5;
